import { useState } from 'react'
import { Shield, Users, FolderOpen, Settings, Clock } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { AdminProjectsManager } from '@/components/admin/AdminProjectsManager'
import { AdminUsersManager } from '@/components/admin/AdminUsersManager'
import { AdminWaitlistManager } from '@/components/admin/AdminWaitlistManager'

export function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('projects')

  return (
    <div className="min-h-screen bg-background">
      <div className="border-b">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center gap-3">
            <Shield className="h-8 w-8 text-primary" />
            <div>
              <h1 className="text-2xl font-bold">AionTrack Admin</h1>
              <p className="text-sm text-muted-foreground">
                Manage projects, users, and feature flags
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-6 py-8">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList className="grid w-full max-w-2xl grid-cols-3">
            <TabsTrigger value="projects" className="flex items-center gap-2">
              <FolderOpen className="h-4 w-4" />
              Projects
            </TabsTrigger>
            <TabsTrigger value="users" className="flex items-center gap-2">
              <Users className="h-4 w-4" />
              Users
            </TabsTrigger>
            <TabsTrigger value="waitlist" className="flex items-center gap-2">
              <Clock className="h-4 w-4" />
              Waitlist
            </TabsTrigger>
          </TabsList>

          <TabsContent value="projects" className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Settings className="h-5 w-5" />
                  Project Management
                </CardTitle>
                <CardDescription>
                  View all projects and manage feature flags for each project
                </CardDescription>
              </CardHeader>
              <CardContent>
                <AdminProjectsManager />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="users" className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Users className="h-5 w-5" />
                  User Management
                </CardTitle>
                <CardDescription>
                  View all users and their projects
                </CardDescription>
              </CardHeader>
              <CardContent>
                <AdminUsersManager />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="waitlist" className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Clock className="h-5 w-5" />
                  Waitlist Management
                </CardTitle>
                <CardDescription>
                  Manage waitlisted users and their inquiries
                </CardDescription>
              </CardHeader>
              <CardContent>
                <AdminWaitlistManager />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  )
}
